module.exports = __webpack_public_path__ + "img/1535x1535_Zeppelin-Baggerboerse_v2.830441c5.jpg";